import DialogSubscriber from '~/components/dialog/subscriber/DialogSubscriber.vue';

export const useActionDialogNewSubscriber = () => {
  const { onPlay, complete } = useAbstractAction(
    'actionDialogNewSubscriber',
    false
  );

  const hasPlayedNewSubscriberDialog = useNomadStorage(
    'hasPlayedNewSubscriberDialog',
    false,
    'family'
  );

  const profile = useProfileStore();

  const dialog = useDialogStore();

  onPlay(async () => {
    if (
      profile.isASubscriber &&
      !hasPlayedNewSubscriberDialog.value &&
      (!profile.isParent || (profile.isParent && profile.children.length > 0))
    ) {
      hasPlayedNewSubscriberDialog.value = true;
      dialog.open(DialogSubscriber, {
        onClose: () => {
          complete(true);
        },
      });
    } else {
      complete(false);
    }
  });
};
